import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
const HIGHLIGHT_TIME = 2000;
export function useScrollToHighlightedPage({ ref, pageId }) {
    const [isHighlighted, setIsHighlighted] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const isHighlightedItem = searchParams.get('pageId') === pageId;
    useEffect(function scrollToCardIfHighlighted() {
        if (!isHighlightedItem || !ref?.current)
            return;
        const observer = new MutationObserver(() => {
            requestAnimationFrame(() => {
                ref.current.scrollIntoView({ block: 'center', behavior: 'smooth' });
                setIsHighlighted(true);
                setTimeout(() => setIsHighlighted(false), HIGHLIGHT_TIME);
                const newParams = new URLSearchParams(searchParams);
                newParams.delete('pageId');
                newParams.delete('moduleId');
                setSearchParams(newParams);
                observer.disconnect();
            });
        });
        observer.observe(ref.current, {
            attributes: true,
            childList: true,
            subtree: true
        });
        return () => observer.disconnect();
    }, [isHighlightedItem, ref, searchParams, setSearchParams]);
    return isHighlighted;
}
